import {PersonalizeResultsButtonService} from "../search/personalization/personalizationButton/personalizeResultsButton.service";
import {bundle, getInjectableName as gI} from 'ng-metadata/core';
import {FullViewModuleLoaderService} from "../search/fullView/fullViewModuleLoader.service";
import {SilentLoginService} from "./silentLogin/silentLogin.service";
import {getUnionViewScopeSuffix, isUnionCatalogMemberView} from "../appConfig/appConfigForward";
const forEach = require('lodash/forEach');
const uiRouter = require('angular-ui-router');
const angular: angular.IAngularStatic = require('angular');
let app = angular.module('primo-explore.states', [uiRouter]);
export default app;

const _endsWith = require('lodash/endsWith')
export const STATE_NAMES = {
    FAVORITES: 'exploreMain.favorites',
    SEARCH: 'exploreMain.search',
    TAGS: 'tags',
    CITATION_TRAILS: 'exploreMain.citationTrails',
    CITATION_LINKER: 'exploreMain.citationlinker',
    CITATION_CHAPTERS: 'exploreMain.chapters',
    CITATION_REVIEWS: 'exploreMain.chapters',
    EMAIL_TEMPLATE: 'emailTemplate',
	FULL_DISPLAY : 'fulldisplay',
    SEO_FULL_DISPLAY : 'seoFulldispaly',
    SOURCE_RECORD : 'sourceRecord',
    JOURNAL_SEARCH : 'exploreMain.jsearch',
    JOURNAL_FULL_DISPLAY : 'jfulldisplay',
    NEWSPAPERS_FULL_DISPLAY : 'npfulldisplay',
    DB_SEARCH : 'exploreMain.dbsearch',
    NEWSPAPERS : 'exploreMain.npsearch',
    DB_FULL_DISPLAY : 'dbfulldisplay',
    BLANK_ILL : 'blankIll',
    PURCHASE_REQUEST : 'purchaseRequest',
    BROWSE_SEARCH: 'exploreMain.browseSearch',
    BROWSE_HEADER_RESULTS: 'exploreMain.browseSearchResults',
    COLLECTION_DISCOVERY: 'exploreMain.collectionDiscovery',
    SERVICE_PAGE: 'servicesPage',
    LEGANTO_GETIT: 'legantoGetIt',
    DELIVERY:'delivery',
    DELIVERY_CANON:'canonDelivery',
    DELIVERY_CNAME:'cnameDelivery',
    LOGIN: 'login',
    ORGANIZATION_LIST: 'exploreMain.orgList',
    RAPIDO_VIEWIT: 'RapidoViewIt'
};

app.config(configureStates);

let waitForSilentLogin= ['$q', gI(SilentLoginService), ($q: ng.IQService, silentLoginService: SilentLoginService)=>{
    return $q((resolve, reject)=>{
        silentLoginService.silentLoginAppDelayTimer.then(()=>{
            resolve();
        }, (error) => {
            // nothing to do but need to handle error, so we don't get unhandled rejection error in console
        })
        silentLoginService.silentLoginInprogressPromise.then(()=>{
            resolve();
        })
    });
}];

let updateUnionViewParams = ['$stateParams', ($stateParams)=>{
    if (isUnionCatalogMemberView()){
        let unionViewScopeSuffix = getUnionViewScopeSuffix();
        if ($stateParams['search_scope'] && !_endsWith($stateParams['search_scope'], unionViewScopeSuffix)){
            $stateParams['search_scope'] = $stateParams['search_scope'] + unionViewScopeSuffix;
        }
        if ($stateParams['tab'] && !_endsWith($stateParams['tab'], unionViewScopeSuffix)){
            $stateParams['tab'] = $stateParams['tab'] + unionViewScopeSuffix;
        }
    }

}];


function personalizationConfiguration(personalizeResultsButtonService) {
    return personalizeResultsButtonService.promise;
}
personalizationConfiguration.$inject=[gI(PersonalizeResultsButtonService)];

function configureStates($stateProvider, $urlRouterProvider) {

    let $delegate = $stateProvider.state;
    //this allows us to add resolve functions for all states
    $stateProvider.state = function(name, definition) {
        definition.resolve = angular.extend({}, definition.resolve, {
            //resolve functions added here will be added to all states
            updateUnionViewParams: updateUnionViewParams
        });

        return $delegate.apply(this, arguments);
    };

    /* Because of PRM-37348 and according to Angular routing issue #6837 (https://github.com/angular/angular.js/issues/6837),
     when the encoding is not UTF-8 the parameter turns to "undefined". When the parameter starts with "%u" it means
     that the bits after it are UTF-16 encoded. The check is if the parameter starts with "%u" and have 4 digits or 'a-f',
     then decode it with UTF-16, else do nothing and the parameter turns to undefined. */
    if (window.location.search.indexOf("%u") > -1) {
        let match = window.location.search.match(/%u([0-9a-f]{4})/);
        if (match) {
            window.location.search = window.location.search.replace(match[0], decodeUTF16LE(match[1]));
        }
    }

    $stateProvider.state('exploreMain', {
        abstract: true,
        template: '<prm-explore-main></prm-explore-main>',
        reloadOnSearch: true
    });

    $stateProvider.state(STATE_NAMES.SEARCH, {
	    url: '/search?query&pfilter&tab&search_scope&sortby&vid&facet&mfacet&lang&mode&offset&pcAvailability?browseQuery&browseFirstTerm&browseScope&innerPnxIndex&numOfUsedTerms&fn&came_from?docCount&show_performance&conVoc&browseParams&authenticationError&fromRedirectFilter&timeout&explain&fromDate&searchCDI&savedSearchId&oSSKey',
        template: `<prm-search
                    (hide-dialog-event)="$ctrl.hideDialog()"
                    (show-dialog-event)="$ctrl.showDialog()">
                    </prm-search>`,
        reloadOnSearch: true,
        resolve: {
            personalizationConfiguration: personalizationConfiguration
        }
    });


    $stateProvider.state(STATE_NAMES.JOURNAL_SEARCH, {
        url: '/jsearch?query&pfilter&tab&search_scope&sortby&vid&facet&mfacet&lang&mode&offset&journals&timeout&explain&databases&searchCDI',
        template: '<prm-journals></prm-journals>',
        reloadOnSearch: true,
        resolve: {
            loadModule: ['$ocLazyLoad', '$q', ($ocLazyLoad, $q)=>{
                return $q((resolve)=>{
                    require.ensure(['..//journals/atoz.module'], (require)=>{
                        let module= require('..//journals/atoz.module');
                        module= bundle(module.AtozModule);
                        $ocLazyLoad.inject(module.name).then(()=>{
                            resolve();
                        });
                    }, (error)=>{
                        console.log(error);
                    }, 'atoz_chunk');
                });
            }]
        }
    });

    $stateProvider.state(STATE_NAMES.JOURNAL_FULL_DISPLAY, {
        url: '/jfulldisplay?vid&search_scope&tab&docid&lang&context&adaptor&isFrbr&showPnx&query&pfilter&sortby&mode&facet&mfacet&journals&timeout&explain&searchCDI',
        template: '<prm-journals-full-view></prm-journals-full-view>',
        reloadOnSearch: true,
        resolve: {
            loadModule: ['$ocLazyLoad', '$q', gI(FullViewModuleLoaderService), ($ocLazyLoad, $q: ng.IQService, fullViewModuleLoaderService: FullViewModuleLoaderService)=>{
                let atozModulePromise= $q((resolve)=>{
                    require.ensure(['..//journals/atoz.module'], (require)=>{
                        let module= require('..//journals/atoz.module');
                        module= bundle(module.AtozModule);
                        $ocLazyLoad.inject(module.name).then(()=>{
                            resolve();
                        });
                    }, (error)=>{
                        console.log(error);
                    }, 'atoz_chunk');
                });
                let fullDisplayModulePromise= fullViewModuleLoaderService.loadFullViewModule();
                return $q.all([atozModulePromise, fullDisplayModulePromise]); //combine both promises to one promise which is resolved only when both are resolved.
            }],
            waitForSilentLogin: waitForSilentLogin
        }
    });

    $stateProvider.state(STATE_NAMES.NEWSPAPERS_FULL_DISPLAY, {
        url: '/npfulldisplay?vid&search_scope&tab&docid&lang&context&adaptor&showPnx&query&sortby&facet&mfacet&timeout',
        template: '<prm-newspapers-full-view></prm-newspapers-full-view>',
        reloadOnSearch: true,
        resolve: {
            loadModule: [gI(FullViewModuleLoaderService), (fullViewModuleLoaderService: FullViewModuleLoaderService)=>{
                return fullViewModuleLoaderService.loadFullViewModule();
            }],
            waitForSilentLogin: waitForSilentLogin
        }

    });

    $stateProvider.state(STATE_NAMES.DB_SEARCH, {
        url: '/dbsearch?query&pfilter&tab&search_scope&sortby&vid&facet&mfacet&lang&mode&offset&databases&showPnx&timeout&explain&searchCDI',
        template: '<prm-databases></prm-databases>',
        reloadOnSearch: true,
        resolve: {
            loadModule: ['$ocLazyLoad', '$q', gI(FullViewModuleLoaderService), ($ocLazyLoad, $q: ng.IQService, fullViewModuleLoaderService: FullViewModuleLoaderService)=>{
                let atozModulePromise= $q((resolve)=>{
                    require.ensure(['..//journals/atoz.module'], (require)=>{
                        let module= require('..//journals/atoz.module');
                        module= bundle(module.AtozModule);
                        $ocLazyLoad.inject(module.name).then(()=>{
                            resolve();
                        });
                    }, (error)=>{
                        console.log(error);
                    }, 'atoz_chunk');
                });
                let fullDisplayModulePromise= fullViewModuleLoaderService.loadFullViewModule();
                return $q.all([atozModulePromise, fullDisplayModulePromise]); //combine both promises to one promise which is resolved only when both are resolved.
            }]
        }
    });

    $stateProvider.state(STATE_NAMES.DB_FULL_DISPLAY, {
        url: '/dbfulldisplay?query&pfilter&tab&docid&context&adaptor&search_scope&isFrbr&sortby&vid&facet&mfacet&lang&mode&offset&databases&showPnx&timeout&explain&searchCDI',
        template: '<prm-databases-full-view></prm-databases-full-view>',
        reloadOnSearch: true,
        resolve: {
            loadModule: ['$ocLazyLoad', '$q', gI(FullViewModuleLoaderService), ($ocLazyLoad, $q: ng.IQService, fullViewModuleLoaderService: FullViewModuleLoaderService)=>{
                let atozModulePromise= $q((resolve)=>{
                    require.ensure(['..//journals/atoz.module'], (require)=>{
                        let module= require('..//journals/atoz.module');
                        module= bundle(module.AtozModule);
                        $ocLazyLoad.inject(module.name).then(()=>{
                            resolve();
                        });
                    }, (error)=>{
                        console.log(error);
                    }, 'atoz_chunk');
                });
                let fullDisplayModulePromise= fullViewModuleLoaderService.loadFullViewModule();
                return $q.all([atozModulePromise, fullDisplayModulePromise]); //combine both promises to one promise which is resolved only when both are resolved.
            }],
            waitForSilentLogin: waitForSilentLogin
        }
    });

    $stateProvider.state(STATE_NAMES.NEWSPAPERS, {
        url: '/npsearch?vid&query&search_scope&sortby&lang&pcAvailability&facet&mfacet&offset&issn&featured_scope&timeout',
        template: '<prm-newspapers-home></prm-newspapers-home>',
        reloadOnSearch: true
    });

    $stateProvider.state(STATE_NAMES.COLLECTION_DISCOVERY, {
        url: '/collectionDiscovery?vid&colayout&inst&collectionId&lang&timeout&query&sortby&sortItemsBy',
        params: {
            currentCollection: undefined,
            items: undefined,
            path: undefined
        },
        template: '<prm-collection-discovery></prm-collection-discovery>',
        reloadOnSearch: true,
        resolve: {
            loadModule: ['$ocLazyLoad', '$q', ($ocLazyLoad, $q)=>{
                return $q((resolve)=>{
                    require.ensure(['../collectionDiscovery/collectionDiscovery.module'], (require)=>{
                        let module= require('../collectionDiscovery/collectionDiscovery.module');
                        module= bundle(module.CollectionDiscoveryModule);
                        $ocLazyLoad.inject(module.name).then(()=>{
                            resolve();
                        });
                    }, (error)=>{
                        console.log(error);
                    }, 'collectionDiscovery_chunk');
                });
            }]
        }
    });

    /* tslint:disable max-line-length */
    $stateProvider.state(STATE_NAMES.SERVICE_PAGE, {
        url: '/openurl?institution&vid&lang&ctx_ver&ctx_enc&ctx_tim&url_ver&url_ctx_fmt&{rfr_id:any}&rft_val_fmt&rft.genre&rft.atitle&atitle&rft.jtitle&jtitle&rft.btitle&btitle&rft.aulast&aulast&rft.auinit&auinit&rft.auinit1&auinit1&rft.auinitm&auinitm&rft.ausuffix&ausuffix&rft.au&au&rft.aucorp&aucorp&rft.volume&volume&rft.issue&issue&rft.part&part&rft.quarter&quarter&rft.ssn&ssn&rft.spage&spage&rft.epage&epage&rft.pages&pages&rft.artnum&artnum&rft.issn&issn&rft.eissn&eissn&rft.isbn&isbn&rft.sici&sici&rft.coden&coden&rft_id&rft.lccn&rft.oclcid&rft.object_id&object_id&rft_dat&rft.eisbn&eisbn&req.language&rft.title&title&dscnt&rft.mms_id&rft.date&rft.doi&rft.pmid&rft.aufirst&rft.publisher&rft.pubdate&dstmp&debug&svc_dat&response_type&req_id&output&fromLogin&u.ignore_date_coverage&url_ctx_val&isSerivcesPage&Force_direct&isCitationLinker&timeout&id&sid&genre&date&searchCDI',
        template: '<prm-services-page></prm-services-page>',
        reloadOnSearch: true,
        resolve: {
            loadModule: [gI(FullViewModuleLoaderService), (fullViewModuleLoaderService: FullViewModuleLoaderService)=>{
                return fullViewModuleLoaderService.loadFullViewModule();
            }],
            waitForSilentLogin: waitForSilentLogin
        }
    });
    
    $stateProvider.state(STATE_NAMES.RAPIDO_VIEWIT, {
        url: '/viewitopenurl?institution&vid&lang&ctx_ver&ctx_enc&ctx_tim&url_ver&url_ctx_fmt&{rfr_id:any}&rft_val_fmt&rft.genre&rft.atitle&atitle&rft.jtitle&jtitle&rft.btitle&btitle&rft.aulast&aulast&rft.auinit&auinit&rft.auinit1&auinit1&rft.auinitm&auinitm&rft.ausuffix&ausuffix&rft.au&au&rft.aucorp&aucorp&rft.volume&volume&rft.issue&issue&rft.part&part&rft.quarter&quarter&rft.ssn&ssn&rft.spage&spage&rft.epage&epage&rft.pages&pages&rft.artnum&artnum&rft.issn&issn&rft.eissn&eissn&rft.isbn&isbn&rft.sici&sici&rft.coden&coden&rft_id&rft.lccn&rft.oclcid&rft.object_id&object_id&rft_dat&rft.eisbn&eisbn&req.language&rft.title&title&dscnt&rft.mms_id&rft.date&rft.doi&rft.pmid&rft.aufirst&rft.publisher&rft.pubdate&dstmp&debug&svc_dat&response_type&req_id&output&fromLogin&u.ignore_date_coverage&url_ctx_val&isSerivcesPage&Force_direct&isCitationLinker&timeout&id&sid&genre&date&searchCDI',
        template: '<prm-services-page></prm-services-page>',
        reloadOnSearch: true,
        resolve: {
            loadModule: [gI(FullViewModuleLoaderService), (fullViewModuleLoaderService: FullViewModuleLoaderService)=>{
                return fullViewModuleLoaderService.loadFullViewModule();
            }],
            waitForSilentLogin: waitForSilentLogin
        }
    });
    
    /* tslint:enable max-line-length */

    $stateProvider.state(STATE_NAMES.FULL_DISPLAY, {
        url: '/fulldisplay?vid&search_scope&tab&docid&id&inst&lang&context&adaptor&isFrbr&showPnx&query&pfilter&sortby&mode&facet&mfacet&offset?&browseQuery&browseFirstTerm&browseScope&innerPnxIndex&numOfUsedTerms&fn&pcAvailability&fromFeaturedResult&originScope&originTab&timeout&explain&virtualBrowse&searchCDI',
        template: '<prm-full-view-page></prm-full-view-page>',
        reloadOnSearch: true,
        resolve: {
            loadModule: [gI(FullViewModuleLoaderService), (fullViewModuleLoaderService: FullViewModuleLoaderService)=>{
                return fullViewModuleLoaderService.loadFullViewModule();
            }],
            waitForSilentLogin: waitForSilentLogin
        }
     });
    
    // for PRM-40995 google SEO : Add canonical tag to Full Display 
   $stateProvider.state(STATE_NAMES.SEO_FULL_DISPLAY, {
     url: '/fulldisplay/:docid/:vid',
      template: '<prm-full-view-page></prm-full-view-page>',
       reloadOnSearch: true,
       resolve: {
                   loadModule: [gI(FullViewModuleLoaderService), (fullViewModuleLoaderService: FullViewModuleLoaderService)=>{
              return fullViewModuleLoaderService.loadFullViewModule();
           }],
          waitForSilentLogin: waitForSilentLogin
      }
    });

    $stateProvider.state(STATE_NAMES.LEGANTO_GETIT, {
        url: '/legantogetit?vid&docid&lang&context&body-bgcolor&GES',
        template: '<prm-leganto-getit></prm-leganto-getit>',
        reloadOnSearch: true,
        resolve: {
            loadModule: [gI(FullViewModuleLoaderService), (fullViewModuleLoaderService: FullViewModuleLoaderService)=>{
                return fullViewModuleLoaderService.loadFullViewModule();
            }],
            waitForSilentLogin: waitForSilentLogin
        }
    });

    $stateProvider.state(STATE_NAMES.FAVORITES, {
        url: '/favorites?vid&label&lang&section&sortBy&timeout',
        template: '<prm-favorites></prm-favorites>',
        reloadOnSearch: true,
        params: {
            section: 'items'
        },
        resolve: {
            loadModule: ['$ocLazyLoad', '$q', ($ocLazyLoad, $q)=>{
                return $q((resolve)=>{
                    require.ensure(['../favorites/favorites.module'], (require)=>{
                        let module= require('../favorites/favorites.module');
                        module= bundle(module.FavoritesModule);
                        $ocLazyLoad.inject(module.name).then(()=>{
                            resolve();
                        });
                    }, (error)=>{
                        console.log(error);
                    }, 'favorites_chunk');
                });
            }]
        }
    });

    $stateProvider.state(STATE_NAMES.TAGS, {
        url: '/tags?vid&label&lang&section&timeout',
        template: '<prm-tags></prm-tags>',
        reloadOnSearch: true
    });

    $stateProvider.state('account', {
        url: '/account?vid&section&lang&timeout',
        template: '<prm-account></prm-account>',
        reloadOnSearch: true,
        resolve: {
           loadModule: ['$ocLazyLoad', '$q', ($ocLazyLoad, $q)=>{
               return $q((resolve)=>{
                   require.ensure(['../account/account.module'], (require)=>{
                       let module= require('../account/account.module');
                       module= bundle(module.AccountModule);
                       $ocLazyLoad.inject(module.name).then(()=>{
                           resolve();
                       });
                   }, (error)=>{
                       console.log(error);
                   }, 'account_chunk');
               });
           }]
        }
    });

    $stateProvider.state('blankIll', {
        url: '/blankIll?vid&timeout',
        template: '<prm-blank_ill></prm-blank_ill>',
        reloadOnSearch: true
    });
    $stateProvider.state('purchaseRequest', {
        url: '/purchaseRequest?vid&timeout',
        template: '<prm-blank-purchase-request></prm-blank-purchase-request>',
        reloadOnSearch: true
    });


   $stateProvider.state('deposit', {
      url: '/deposit?vid&lang&auth&timeout',
       template: '<prm-deposits-link></prm-deposits-link>',
       reloadOnSearch: true,
       resolve: {
           loadModule: ['$ocLazyLoad', '$q', ($ocLazyLoad, $q)=>{
               return $q((resolve)=>{
                   require.ensure(['../account/account.module'], (require)=>{
                       let module= require('../account/account.module');
                       module= bundle(module.AccountModule);
                       $ocLazyLoad.inject(module.name).then(()=>{
                           resolve();
                       });
                   }, (error)=>{
                       console.log(error);
                   }, 'account_chunk');
               });
           }]
       }
   });

      $stateProvider.state(STATE_NAMES.DELIVERY, {
      url: '/delivery?vid&mmsId&repId&lang&timeout&showLogo&mode&viewerServiceCode',
       template: '<prm-alma-viewer></prm-alma-viewer>',
       reloadOnSearch: true,
       resolve: {
           loadModule: ['$ocLazyLoad', '$q', ($ocLazyLoad, $q)=>{
               return $q((resolve)=>{
                   require.ensure(['../delivery/almaViewer/almaViewer.module'], (require)=>{
                       let module= require('../delivery/almaViewer/almaViewer.module');
                       module= bundle(module.AlmaViewerModule);
                       $ocLazyLoad.inject(module.name).then(()=>{
                           resolve();
                       });
                   }, (error)=>{
                       console.log(error);
                   }, 'almaViewer_chunk');
               });
           }]
        }
   });
   
      $stateProvider.state(STATE_NAMES.DELIVERY_CNAME, {
    url: '/delivery/:pid?lang&timeout&showLogo&mode&viewerServiceCode',
     template: '<prm-alma-viewer></prm-alma-viewer>',
     reloadOnSearch: true,
     resolve: {
         loadModule: ['$ocLazyLoad', '$q', ($ocLazyLoad, $q)=>{
             return $q((resolve)=>{
                 require.ensure(['../delivery/almaViewer/almaViewer.module'], (require)=>{
                     let module= require('../delivery/almaViewer/almaViewer.module');
                     module= bundle(module.AlmaViewerModule);
                     $ocLazyLoad.inject(module.name).then(()=>{
                         resolve();
                     });
                 }, (error)=>{
                     console.log(error);
                 }, 'almaViewer_chunk');
             });
         }]
      }
 });
   
       $stateProvider.state(STATE_NAMES.DELIVERY_CANON, {
      url: '/delivery/:vid/:pid?lang&timeout&showLogo&mode&viewerServiceCode',
       template: '<prm-alma-viewer></prm-alma-viewer>',
       reloadOnSearch: true,
       resolve: {
           loadModule: ['$ocLazyLoad', '$q', ($ocLazyLoad, $q)=>{
               return $q((resolve)=>{
                   require.ensure(['../delivery/almaViewer/almaViewer.module'], (require)=>{
                       let module= require('../delivery/almaViewer/almaViewer.module');
                       module= bundle(module.AlmaViewerModule);
                       $ocLazyLoad.inject(module.name).then(()=>{
                           resolve();
                       });
                   }, (error)=>{
                       console.log(error);
                   }, 'almaViewer_chunk');
               });
           }]
        }
   });

    $stateProvider.state('static', {
        url: '/static-file/:section?vid&lang&timeout',
        template: '<prm-static-page></prm-static-page>',
        reloadOnSearch: true
    });

    $stateProvider.state(STATE_NAMES.EMAIL_TEMPLATE, {
        url: '/email-template?vid&lang&timeout',
        template: '<prm-email-template></prm-email-template>',
        params: {items: undefined, note: undefined},
        reloadOnSearch: true,
        resolve: {
            loadModule: [()=>{
                forEach(document.querySelectorAll('link[rel="stylesheet"]'), (el) => {
                    el.parentNode.removeChild(el);
                })
            }]
        }
    });

    $stateProvider.state(STATE_NAMES.LOGIN, {
        url: '/login?vid&lang&timeout&toState&toParams&unionCatalogNZVid',
        template: '<prm-stand-alone-login></prm-stand-alone-login>',
        reloadOnSearch: true
    });

    $stateProvider.state(STATE_NAMES.CITATION_TRAILS, {
        url: '/citationTrails?query&search_scope&tab&vid&facet&mfacet&lang&adaptor&active&seed_id&timeout&explain&searchCDI&offset&came_from',
		params: { seedInfo: null},
        template: '<prm-citation-trails-breadcrumbs></prm-citation-trails-breadcrumbs>',
        reloadOnSearch: true
    });

    $stateProvider.state(STATE_NAMES.SOURCE_RECORD, {
    url: '/sourceRecord?vid&docId&recordOwner&timeout',
    template: '<prm-source-record></prm-source-record>',
    reloadOnSearch: true
    });

    $stateProvider.state(STATE_NAMES.CITATION_LINKER, {
        url: '/citationlinker?vid&lang&timeout',
        template: '<prm-citation-linker></prm-citation-linker>',
        reloadOnSearch: true
    });

    $stateProvider.state(STATE_NAMES.CITATION_CHAPTERS, {
        url: '/chapters?vid&lang&timeout&query&search_scope&tab&type&adaptor&docid&facet&mfacet&isRelatedItems&context&offset',
        template: '<prm-chapters-and-reviews></prm-chapters-and-reviews>',
        reloadOnSearch: true
    });


    $stateProvider.state('model', {
        url: '/model?vid',
        template: '<prm-model></prm-model>',
        reloadOnSearch: false
    }).state('model.active', {
        url: '/:active',
        template: '<prm-model></prm-model>',
        reloadOnSearch: false
    }).state('model.entry', {
        url: '/:active/:entry',
        template: '<prm-model></prm-model>',
        reloadOnSearch: false
    }).state('model.bulk', {
        url: '/:active/:entry/:bulk',
        template: '<prm-model></prm-model>',
        reloadOnSearch: false
    }).state('model.entry2', {
        url: '/:active/:entry/:bulk/:entry2',
        template: '<prm-model></prm-model>',
        reloadOnSearch: false
    }).state('model.detail', {
        url: '/:active/:entry/:bulk/:entry2/:index',
        template: '<prm-model></prm-model>',
        reloadOnSearch: false
    });

    // $stateProvider.state('browseSearchMain', {
    //     abstract: true,
    //     template: '<prm-browse-main></prm-browse-main>',
    //     reloadOnSearch: true
    // });

    $stateProvider.state(STATE_NAMES.BROWSE_SEARCH, {
        url: '/browse?vid&browseQuery&browseScope&browseFirstTerm&innerPnxIndex&numOfUsedTerms&fn&timeout&explain&searchCDI&offset',
        template: '<prm-browse-search></prm-browse-search>',
        reloadOnSearch: true
    });

    $stateProvider.state(STATE_NAMES.BROWSE_HEADER_RESULTS, {
        url: '/browse/results?vid&query&browseQuery&browseFirstTerm&timeout&explain&searchCDI',
        template: '<prm-browse-header-results></prm-browse-header-results>',
        reloadOnSearch: true
    });


    $stateProvider.state(STATE_NAMES.ORGANIZATION_LIST, {
        url: '/orgList?vid&query&sortby&timeout&searchCDI&showPnx&organization&organizationPath&tab&search_scope&facet&mfacet&offset',
        template: '<prm-organizations></prm-organizations>',
        reloadOnSearch: true,
        resolve: {
            loadModule: ['$ocLazyLoad', '$q', gI(FullViewModuleLoaderService), ($ocLazyLoad, $q: ng.IQService, fullViewModuleLoaderService: FullViewModuleLoaderService)=>{
                let atozModulePromise= $q((resolve)=>{
                    require.ensure(['..//journals/atoz.module'], (require)=>{
                        let module= require('..//journals/atoz.module');
                        module= bundle(module.AtozModule);
                        $ocLazyLoad.inject(module.name).then(()=>{
                            resolve();
                        });
                    }, (error)=>{
                        console.log(error);
                    }, 'atoz_chunk');
                });
                let fullDisplayModulePromise= fullViewModuleLoaderService.loadFullViewModule();
                return $q.all([atozModulePromise, fullDisplayModulePromise]); //combine both promises to one promise which is resolved only when both are resolved.
            }]
        }
    });


    $urlRouterProvider.otherwise(function ($injector, $location) {
        let state = $injector.get('$state');
        let newState = STATE_NAMES.SEARCH;
        let loc = $location.path();
        //This section deals with the implementation of Primo Ui running
        // primo-explore directives in jsp's (collection)

        if (loc.indexOf('.do') > -1) {
            /*in the old ui we use the bundled app to present the login pages
             in this case we dont want to actually activate the primo-explore app
             at all - we just want to use material*/
            if (loc.indexOf('login.do') === -1 && loc.indexOf('loginpage.do') === -1) {
                // For Primo UI links (Main menu - eshelf,My account...) - we dont want angular to route at all
                window.location = $location.absUrl();
            }
        } else {
            state.go(newState, $location.search()); // here we get { query: ... }
        }
    });

}

configureStates.$inject = ['$stateProvider', '$urlRouterProvider'];


// This function is reduced from https://onlineutf8tools.com/js/bridges/convert-utf16-to-utf8.js
function decodeUTF16LE( input: string ) {
    let out: string = "";

    let bom = 'be';
    if (/^feff/.test(input)) {
        bom = 'be';
    }
    else if (/^fffe/i.test(input)) {
        bom = 'le';
    }

    let parsedInput = parseInt(input, 16);
    if (bom == 'le') {
        // convert to be
        let b2 = (parsedInput & 0xff00) >> 8;
        let b1 = parsedInput & 0x00ff;
        parsedInput = (b1 << 8) | b2;
    }

    out += String.fromCodePoint(parsedInput);
    return out;
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/primoExploreStates.module.ts